import { render, staticRenderFns } from "./PayBoxConfiguration.vue?vue&type=template&id=5a90ca91&scoped=true&"
import script from "./PayBoxConfiguration.vue?vue&type=script&lang=js&"
export * from "./PayBoxConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a90ca91",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a90ca91')) {
      api.createRecord('5a90ca91', component.options)
    } else {
      api.reload('5a90ca91', component.options)
    }
    module.hot.accept("./PayBoxConfiguration.vue?vue&type=template&id=5a90ca91&scoped=true&", function () {
      api.rerender('5a90ca91', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/pdv/pay-box-configuration/PayBoxConfiguration.vue"
export default component.exports